import { Fragment, type CSSProperties, type ReactNode } from 'react';
import type { Locale } from '@arbuz/shared';
import { haptic } from '../tg';
import { makeT } from '../i18n';

export type ThemedIconName =
  | 'watermelon'
  | 'delivery'
  | 'order'
  | 'guarantee'
  | 'location'
  | 'phone'
  | 'home'
  | 'orders'
  | 'favorites'
  | 'profile'
  | 'calendar'
  | 'clock'
  | 'comment'
  | 'cash'
  | 'card';

export function ThemedIcon({ name }: { name: ThemedIconName }) {
  switch (name) {
    case 'watermelon':
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true" className="client-themed-icon">
          <path d="M4.5 16.4c3.1 3.1 8.3 3.3 11.7.4 1.7-1.5 2.8-3.5 3.1-5.8L4.5 16.4Z" fill="#4e8135" />
          <path d="M6.3 15.7c2.6 2 6.3 2 8.8-.2 1.1-.9 1.9-2.1 2.3-3.5L6.3 15.7Z" fill="#f8fff2" />
          <path d="M8.1 15c2 1.1 4.4.9 6.2-.7.7-.6 1.2-1.2 1.6-2L8.1 15Z" fill="#ef5c54" />
          <path d="M11.4 14.1c.1.5-.1.9-.4 1-.4.1-.7-.2-.8-.7-.1-.5.1-.9.4-1 .4-.1.7.2.8.7ZM14 13.1c.1.4-.1.8-.4.9-.3.1-.7-.2-.8-.6-.1-.4.1-.8.4-.9.3-.1.7.2.8.6Z" fill="#231711" />
        </svg>
      );
    case 'delivery':
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true" className="client-themed-icon">
          <path d="M4 14.5h8.2l2.1-4.3h2.8c1.4 0 2.6.9 3 2.2l.5 1.6" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M6.3 17.4a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM17.5 17.4a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" fill="#eaf1e5" stroke="currentColor" strokeWidth="1.5" />
          <path d="M8.1 8.4h4.8M6.7 10.8h5" stroke="#ef5c54" strokeWidth="1.7" strokeLinecap="round" />
        </svg>
      );
    case 'order':
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true" className="client-themed-icon">
          <path d="M7 4.8h10a1.8 1.8 0 0 1 1.8 1.8v11.1a1.8 1.8 0 0 1-1.8 1.8H7a1.8 1.8 0 0 1-1.8-1.8V6.6A1.8 1.8 0 0 1 7 4.8Z" fill="#fff" stroke="currentColor" strokeWidth="1.7" />
          <path d="M9.2 4h5.6v2.7H9.2V4Z" fill="#eaf1e5" stroke="currentColor" strokeWidth="1.5" />
          <path d="M8.8 10.3h6.4M8.8 13.4h5.1M8.8 16.5h4.3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
      );
    case 'guarantee':
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true" className="client-themed-icon">
          <path d="M12 3.8 18 6v4.9c0 3.8-2.4 7.2-6 8.5-3.6-1.3-6-4.7-6-8.5V6l6-2.2Z" fill="#eaf1e5" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" />
          <path d="m8.9 12.1 2 2 4.3-4.6" fill="none" stroke="#4e8135" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
    case 'location':
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true" className="client-themed-icon">
          <path d="M12 20s6-5.4 6-10.2a6 6 0 0 0-12 0C6 14.6 12 20 12 20Z" fill="#eaf1e5" stroke="currentColor" strokeWidth="1.8" />
          <circle cx="12" cy="9.8" r="2.1" fill="#4e8135" />
        </svg>
      );
    case 'phone':
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true" className="client-themed-icon">
          <path d="M7.5 5.1h9A1.5 1.5 0 0 1 18 6.6v10.8a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 6 17.4V6.6a1.5 1.5 0 0 1 1.5-1.5Z" fill="#fff" stroke="currentColor" strokeWidth="1.7" />
          <path d="M10 7.6h4M11 16.4h2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
          <path d="M9 11.2c1.7-1.3 4.3-1.3 6 0" fill="none" stroke="#ef5c54" strokeWidth="1.7" strokeLinecap="round" />
        </svg>
      );
    case 'home':
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true" className="client-themed-icon">
          <path d="M4.8 11.2 12 5l7.2 6.2" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M7.1 10.5v8h9.8v-8" fill="#fff" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" />
          <path d="M10.4 18.5v-4h3.2v4" fill="#eaf1e5" stroke="currentColor" strokeWidth="1.4" />
        </svg>
      );
    case 'orders':
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true" className="client-themed-icon">
          <path d="M7.2 6h9.6l1 13H6.2l1-13Z" fill="#fff" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" />
          <path d="M9.2 8.3a2.8 2.8 0 0 1 5.6 0" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
          <path d="M9 12h6M9 15h4" stroke="#4e8135" strokeWidth="1.6" strokeLinecap="round" />
        </svg>
      );
    case 'favorites':
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true" className="client-themed-icon">
          <path d="M12 18.8s-6.3-3.6-6.3-8.1A3.4 3.4 0 0 1 12 8.8a3.4 3.4 0 0 1 6.3 1.9c0 4.5-6.3 8.1-6.3 8.1Z" fill="#fff" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
        </svg>
      );
    case 'profile':
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true" className="client-themed-icon">
          <circle cx="12" cy="8.5" r="3" fill="#eaf1e5" stroke="currentColor" strokeWidth="1.7" />
          <path d="M6.5 19c.7-3 2.6-4.6 5.5-4.6s4.8 1.6 5.5 4.6" fill="#fff" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
        </svg>
      );
    case 'calendar':
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true" className="client-themed-icon">
          <path d="M5.5 7.2h13v10.5a1.3 1.3 0 0 1-1.3 1.3H6.8a1.3 1.3 0 0 1-1.3-1.3V7.2Z" fill="#fff" stroke="currentColor" strokeWidth="1.7" />
          <path d="M8.5 5v4M15.5 5v4M5.8 10.4h12.4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
          <path d="M8.4 13.1h1.8M12 13.1h1.8M8.4 16h1.8M12 16h1.8" stroke="#4e8135" strokeWidth="1.4" strokeLinecap="round" />
        </svg>
      );
    case 'clock':
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true" className="client-themed-icon">
          <circle cx="12" cy="12" r="7.2" fill="#fff" stroke="currentColor" strokeWidth="1.7" />
          <path d="M12 8v4.2l3 1.8" stroke="#4e8135" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
    case 'comment':
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true" className="client-themed-icon">
          <path d="M5.5 6.3h13v8.4a1.7 1.7 0 0 1-1.7 1.7h-4.4L8 19v-2.6H7.2a1.7 1.7 0 0 1-1.7-1.7V6.3Z" fill="#fff" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" />
          <path d="M8.6 9.7h6.8M8.6 12.5h4.4" stroke="#4e8135" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
      );
    case 'cash':
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true" className="client-themed-icon">
          <path d="M4.8 8h14.4v8H4.8V8Z" fill="#fff" stroke="currentColor" strokeWidth="1.7" strokeLinejoin="round" />
          <circle cx="12" cy="12" r="2.2" fill="#eaf1e5" stroke="#4e8135" strokeWidth="1.4" />
          <path d="M7.2 10v4M16.8 10v4" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
        </svg>
      );
    case 'card':
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true" className="client-themed-icon">
          <path d="M5 7.2h14a1.4 1.4 0 0 1 1.4 1.4v7.8a1.4 1.4 0 0 1-1.4 1.4H5a1.4 1.4 0 0 1-1.4-1.4V8.6A1.4 1.4 0 0 1 5 7.2Z" fill="#fff" stroke="currentColor" strokeWidth="1.7" />
          <path d="M3.9 10.2h16.2M7.2 14.8h4.6" stroke="#4e8135" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
      );
  }
}

export function ClientTopBar({
  title,
  location,
  onBack,
  right,
}: {
  title?: string;
  location?: string;
  onBack?: () => void;
  right?: ReactNode;
}) {
  if (location) {
    return (
      <div className="client-topbar" style={{ gridTemplateColumns: '1fr var(--tap-min)' }}>
        <div className="client-location">
          <span className="client-icon-circle" style={{ width: 24, height: 24, fontSize: 12 }}>
            <ThemedIcon name="location" />
          </span>
          <span>{location}</span>
        </div>
        {right ?? <span />}
      </div>
    );
  }

  return (
    <div className="client-topbar center">
      {onBack ? (
        <button
          type="button"
          className="client-icon-button"
          aria-label="Назад"
          onClick={() => {
            haptic('light');
            onBack();
          }}
        >
          ←
        </button>
      ) : (
        <span />
      )}
      <div className="client-top-title">{title}</div>
      {right ?? <span />}
    </div>
  );
}

export function BottomAction({
  children,
  secondary,
  transparent,
  className,
}: {
  children: ReactNode;
  secondary?: ReactNode;
  transparent?: boolean;
  className?: string;
}) {
  return (
    <div className={`client-bottom-bar${transparent ? ' transparent' : ''}${className ? ` ${className}` : ''}`}>
      {children}
      {secondary}
    </div>
  );
}

export function StepIndicator({ current }: { current: 1 | 2 | 3 | 4 }) {
  return (
    <div className="checkout-steps" aria-label={`Шаг ${current} из 4`}>
      {([1, 2, 3, 4] as const).map((n, i) => (
        <Fragment key={n}>
          <span
            className={`checkout-dot${n === current ? ' active' : ''}${n < current ? ' done' : ''}`}
            aria-current={n === current ? 'step' : undefined}
          >
            {n}
          </span>
          {i < 3 && (
            <span
              className={`checkout-bar${n < current ? ' done' : ''}`}
              aria-hidden="true"
            />
          )}
        </Fragment>
      ))}
    </div>
  );
}

export function IconCircle({ children, icon }: { children?: ReactNode; icon?: ThemedIconName }) {
  return <span className="client-icon-circle">{icon ? <ThemedIcon name={icon} /> : children}</span>;
}

export function SummaryRow({
  icon,
  label,
  children,
}: {
  icon: ThemedIconName;
  label: string;
  children: ReactNode;
}) {
  return (
    <div className="client-summary-row">
      <IconCircle icon={icon} />
      <div>
        <p className="muted" style={{ margin: 0, fontSize: 'var(--fs-xs)' }}>
          {label}
        </p>
        <div style={{ marginTop: 'var(--s-1)', fontWeight: 'var(--fw-semibold)' }}>
          {children}
        </div>
      </div>
    </div>
  );
}

export function QuantityStepper({
  qty,
  locale,
  onChange,
}: {
  qty: number;
  locale: Locale;
  onChange: (qty: number) => void;
}) {
  const t = makeT(locale);

  return (
    <div className="client-stepper">
      <button type="button" aria-label={t('decrease')} onClick={() => onChange(qty - 1)}>
        −
      </button>
      <strong aria-live="polite">{qty}</strong>
      <button type="button" aria-label={t('increase')} onClick={() => onChange(qty + 1)}>
        +
      </button>
    </div>
  );
}

export function ProductImage({
  src,
  className = '',
  style,
}: {
  src?: string | null;
  className?: string;
  style?: CSSProperties;
}) {
  return (
    <div
      className={`client-product-photo${className ? ` ${className}` : ''}`}
      style={{ ...(src ? { backgroundImage: `url(${src})` } : {}), ...style }}
      aria-hidden="true"
    />
  );
}
